export const validateCvr = (str: string) => {
    return /^\d{8}$/.test(str);
};

export const validateName = (str: string) => {
    return /^[^0-9_;:*@. ]{2,}(?: [^0-9_;:*@. ]{2,})+$/i.test(str);
};

export const zip = (str: string) => {
    return /^\d{4}$/.test(str);
};

export const validatePhone = (str: string) => {
    try {
        str = str.replace(/[^0-9+()]/g, '');
        return /^(?!0+)\d{8}$/.test(str);
    } catch (err) {
        return false;
    }
};

export const validateRegNumber = (str: string) => {
    return /^\d{4}$/.test(str);
};

export const validateAccountNumber = (str: string) => {
    return /^\d{6,10}$/.test(str);
};

export const validateAge = (str: string): boolean => {
    // ages between 18 and 110 is allowed
    const digitRegEx = new RegExp('^(1[89]|[2-9][0-9]|10[0-9]|110)$', 'g');
    return digitRegEx.test(str);
};

export const validateInt = (str: string): boolean => {
    str = str.replace(/[-w.]/g, '');
    return /^\d+$/.test(str);
};

export const validateFloat = (str: string): boolean => {
    str = str.replace(/\./g, '').replace(',', '.');
    return /^[-]?[\d.]+$/.test(str);
};
